export const getUserLocation = async () => {
  try {
    const response = await fetch('https://api.country.is/');
    if (!response.ok) {
      throw new Error('Failed to fetch location data');
    }

    const data = await response.json();
    return data.country;
  } catch (error) {
    console.error('Error getting user location:', error);
    return ''; // mặc định rỗng nếu lỗi
  }
};
